import authTokenUtil from '../../account/authTokenUtil';

// Based on https://blog.logrocket.com/programmatically-downloading-files-browser#creating-download-link
function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';

  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener('click', clickHandler);
    }, 150);
  };

  a.addEventListener('click', clickHandler, false);
  a.click();
}

export default async function download(url: `/${string}`, filename: string) {
  const authToken = authTokenUtil.get();
  const headers = authToken ? { Authorization: authToken } : undefined;
  const res = await fetch(url, { method: 'GET', headers });
  if (!res.ok) {
    throw new Error(res.statusText);
  }
  const blob = await res.blob();
  downloadBlob(blob, filename);
}
